import script from "./index.pc.vue?vue&type=script&setup=true&lang=js"
export * from "./index.pc.vue?vue&type=script&setup=true&lang=js"

import "./index.pc.vue?vue&type=style&index=0&id=4f43e4de&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f43e4de"]])

export default __exports__